import React from 'react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, HERO_IMAGE } from '../data/hvac';
export function Hero() {
  return <section className="bg-navy px-4 py-5 sm:py-7" data-id="element-82" data-mp="eibpbktviu8x">
      <div className="mx-auto max-w-3xl" data-id="element-83" data-mp="9kjvgl9o4y23">
        <p className="text-center text-[10px] font-extrabold uppercase tracking-[0.2em] text-diag sm:text-xs" data-id="element-84" data-mp="9lbhb4dgrhf6">
          🔧 HVAC DIAGNOSTIC READY™
        </p>
        <h1 className="mt-1 text-center text-2xl leading-[1.05] text-white sm:text-4xl" data-id="element-85" data-mp="12a0lxddqa4vo">
          The Complete Visual Troubleshooting System for HVAC Technicians
        </h1>
        <p className="mx-auto mt-2 max-w-2xl text-center text-sm font-medium leading-snug text-white/85 sm:text-base" data-id="element-86" data-mp="x8jjhdfliacz">
          Stop wasting time searching through scattered charts, manuals and references when
          you need to troubleshoot an HVAC problem.
        </p>
        <p className="mx-auto mt-2 max-w-2xl text-center text-sm font-medium leading-snug text-white/85 sm:text-base" data-id="element-87" data-mp="3d2tqbf4z2uh6">
          Get visual diagnostic maps, troubleshooting flows, testing pathways, component
          references, pressure patterns and symptom-based resources — organized in one
          professional system.
        </p>

        <a href={CHECKOUT_URL} className="mt-3 block" data-id="element-88" data-mp="39al9qe68qo35">
          <img src={HERO_IMAGE} alt="HVAC DIAGNOSTIC READY™ — 6 diagnostic modules and 4 bonuses shown on desktop, tablet and phone" className="mx-auto w-full max-w-xl" data-id="element-89" data-mp="39a35ovdc75ko" />
        </a>

        <CTAButton className="mx-auto mt-2 max-w-md" data-id="element-90" data-mp="358rckfv9827q">
          🔧 YES! I WANT THE COMPLETE SYSTEM
        </CTAButton>
        <p className="mt-2 text-center text-xs font-semibold text-white/80" data-id="element-91" data-mp="2qkdd8ex1qvvx">
          🛡️ 7-Day Money-Back Guarantee
        </p>
      </div>
    </section>;
}